import React, {Component} from 'react';

import {connect} from 'react-redux';
import {authSelectors} from "../../store/auth";
import {calendarActions, calendarSelectors} from "../../store/calendar";

import {withFirebase} from "../../components/Firebase";
import Layout from '../../components/Layout'
import Loading from '../../components/Base/Loading'

import ManageCalendar from '../../pages/Calendar/ManageCalendar'

class ManageCalendarContainer extends Component {

	state = {
		staged: null,
		updating: false,
		loading: false
	}

	componentDidMount() {
		this.categoryListener = this.returnCategoryListener()
	}



	// Main category listener, updates anytime changes are made
	returnCategoryListener = () => {
		return this.props.firebase.categories().orderBy('created_at', 'asc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
			// updateCategories(result)
			this.fetchCategorySchedule(result)
		})
	}

	// fetches subcategories and schedules as one
	fetchCategorySchedule = async (categories) => {
		const {updating} = this.state;
		const {updateCategories, currentDate} = this.props;

		try {
			for(let i in categories){
				// see if category has schedule date, otherwise create
				let activatedScheduleRef = await this.props.firebase.calendarSchedule(categories[i].id, currentDate).get()
				if(!activatedScheduleRef.exists){
					activatedScheduleRef = await this.handleAddScheduleDate(categories[i].id)
				}

				// fetch list or activated subcategories for date/category
			  const activatedSchedule = {id: activatedScheduleRef.id, ...activatedScheduleRef.data()}
				let scheduleRef = await this.props.firebase.calendarSubcategories(categories[i].id).get()

				let result = []
				scheduleRef.docs.forEach(doc => (result.push({id: doc.id, activated: activatedSchedule.schedule.includes(doc.id), ...doc.data()})) )
				categories[i].schedule = result
				categories[i].activated = activatedSchedule

			}
			!updating && updateCategories(categories)

		} catch (error) {
			console.log('Failed to fetch schedule', error)
		}
	}

  // category is the category ID
	// This creates the schedule object for the current data
	handleAddScheduleDate = async (category) => {
		const {currentDate} = this.props;
		try {
			await this.props.firebase.calendarSchedules(category).doc(currentDate).set({
				date: currentDate,
				schedule: [
				]
			})

			return await this.props.firebase.calendarSchedule(category, currentDate).get()
		} catch (error){
			console.log('Failed to create schedule', error)
		}
	}


	saveStagedChanges = async (stagedChanges) => {
		this.setState({updating: true})
		let newCategories = stagedChanges.filter(item => item.id.split('-')[0] === 'new')
		let originalCategories = stagedChanges.filter(item => item.id.split('-')[0] !== 'new')

		try{
			// for new categories, create category then update/create schedules with new category ID
			for(let i in newCategories){
				let newCategory = newCategories[i]
				let categorySchedule = newCategory.schedule
				let newSchedule = categorySchedule.filter(item => item.id.split('-')[0] === 'new')
				delete newCategory.schedule
				delete newCategory.id
				let newCategoryID = await this.handleSubmitNewCategory(newCategory)
				this.handleAddScheduleDate(newCategoryID)
				let newActivated = []
				for(let j in newSchedule){
					console.log('newSchedule', newSchedule)
					// if staged schedule is activated, push id to new Activated list to update the categoires schedule below
					if(newSchedule.activate === true){
						newActivated.push(newSchedule[j].id)
					}
					await this.handleSubmitNewSubCategory({...newSchedule[j], category: newCategoryID})
				}

				let createdCategory = await this.props.firebase.catgory(newCategoryID).get()
				console.log(createdCategory.doc())
				// await this.handleUpdateSchedule([...newActivated], newCategoryID)


			}

			// for existing categories, update/create schedules with existing ID
			for(let s in originalCategories){
				let categorySchedule = originalCategories[s].schedule
				let originalSchedule = categorySchedule.filter(item => item.id.split('-')[0] !== 'new' && item.stagedChanges)
				let newSchedule = categorySchedule.filter(item => item.id.split('-')[0] === 'new')
				let newActivated = []
				for(let j in newSchedule){
					delete newSchedule[j].id
					console.log('newSchedule', newSchedule)

					// if staged schedule is activated, push id to new Activated list to update the categoires schedule below
					if(newSchedule.activate === true){
						newActivated.push(newSchedule[j].id)
					}
					await this.handleSubmitNewSubCategory({...newSchedule[j], category: originalCategories[s].id})
				}

				for(let x in originalSchedule){
					delete originalSchedule[x].stagedChanges
					await this.handleUpdateSubCategory({...originalSchedule[x], category: originalCategories[s].id})
				}

				// update newly created Category with newly created and activated subcategories for the currentdate
				let newScheduleValues = originalCategories[s].activated
				newScheduleValues.schedule = [...newScheduleValues.schedule, ...newActivated]
				await this.handleUpdateSchedule(newScheduleValues, originalCategories[s].id)
			}
		} catch (error) {
			console.log("Failed to save staged changes", error)
		}
		this.setState({updating: false})


	}

	handleSubmitNewCategory = async (values) => {
		const {firebase, profile} = this.props;
		const isValid = await this.validateCategoryName(values)
		// const isValid = true
		if(isValid === true){
			try {

				const newCategoryRef = await firebase.categories().add({
					name: values.name,
					creator_uid: profile.id,
					created_at: Math.floor(Date.now() / 1000),
					last_updated: Math.floor(Date.now() / 1000),
					schedule: []
				})
				console.log(newCategoryRef.id)
				return newCategoryRef.id
			} catch (error) {
				console.log("Failed New Category submit", error)
			}
		} else {
			return {name: "Category with name already exists"}
		}

	}

	handleSubmitNewSubCategory = async (values) => {
		console.log('new schedule values', values)
		const {firebase, profile, currentDate} = this.props;
		const categoryID = values.category
		const isValid = await this.validateSubCategoryName(values, categoryID)

		if(isValid){
			try {
				const isActivated = values.activated
				delete values.category
				delete values.activated
				const timestamp = Math.floor(Date.now() / 1000)

				let newSubCategoryRef = await firebase.calendarSubcategories(categoryID).add({
					...values,
					creator_uid: profile.id,
					created_at: timestamp,
					last_updated: timestamp,
				})

				let newSubcategory = await newSubCategoryRef.get()
				console.log(newSubcategory.id)

				if(isActivated){
					let categoryScheduleRef = await firebase.calendarSchedule(categoryID, currentDate).get()
					let scheduleData = {
						...categoryScheduleRef.data()
					}
					scheduleData.schedule.push(newSubcategory.id)
					await firebase.calendarSchedule(categoryID, currentDate).update({...scheduleData, last_updated: timestamp})
				}
				firebase.category(categoryID).update({
					last_updated: timestamp
				})

			} catch (error){
				console.log('failed to save schedule', error)
			}
		}

	}

	handleUpdateSubCategory = async (values) => {
		console.log(values)
		const {firebase} = this.props;
		const timestamp = Math.floor(Date.now() / 1000)

		try {
			const categoryID = values.category
			delete values.category
			delete values.activated

			const scheduleID = values.id
			delete values.id
			firebase.calendarSubcategory(categoryID, scheduleID).update({
				...values,
				last_updated: timestamp
			})

			firebase.category(categoryID).update({
				last_updated: timestamp,
				// update_history: firebase.firestore.FieldValue.arrayUnion(({uid: profile.id, updated_at: timestamp}))
			})
		} catch (error) {
			console.log('failed to update schedule', error)
		}
	}



	handleUpdateSchedule = async (values, categoryID) => {
		console.log(values)
		const {firebase} = this.props;
		const timestamp = Math.floor(Date.now() / 1000)

		try {
			const scheduleID = values.id
			delete values.id
			firebase.calendarSchedule(categoryID, scheduleID).update({
				...values,
				last_updated: timestamp
			})

			firebase.category(categoryID).update({
				last_updated: timestamp,
				// update_history: firebase.firestore.FieldValue.arrayUnion(({uid: profile.id, updated_at: timestamp}))
			})
		} catch (error) {
			console.log('failed to update schedule', error)
		}
	}

	validateCategoryName = async (values) => {
		try {
			let categoryRef = await this.props.firebase.categories().where('name', '==', values.name).get()
			console.log(categoryRef.docs)
			if(categoryRef.docs.length > 0){
				return false
			} else {
				return true
			}
		} catch(err){
			console.log('error validating', err)
			return false
		}
	}

	validateSubCategoryName = async (values, categoryID) => {
		try {
			let categoryRef = await this.props.firebase.calendarSubcategories(categoryID).where('name', '==', values.name).get()
			console.log(categoryRef.docs)
			if(categoryRef.docs.length > 0){
				return false
			} else {
				return true
			}
		} catch(err){
			console.log('error validating', err)
			return false
		}
	}

	componentWillUnmount() {
		this.categoryListener()
	}

	render() {
		const { loading} = this.state;
		const {profile, currentDate, updateStaged, stagedChanges} = this.props;
		let isLoading = false
		if(profile === null || profile === undefined){
			isLoading = true
		}
		if(loading === true){
			isLoading = true
		}

		return (
			<Layout {...this.props} calendar>
				{isLoading ? <Loading/> :
					<ManageCalendar
						categories={stagedChanges}
						updateStaged={updateStaged}
						handleSubmitStaged={this.saveStagedChanges}
						currentDate={currentDate}
					/>
				}

			</Layout>
		);
	}
}

function mapStateToProps(state) {
	return {
		loadingProfile: authSelectors.isLoading(state.auth),
		loadingCategories: calendarSelectors.isLoading(state.calendar),
		categories: calendarSelectors.refreshCategories(state.calendar),
		currentDate: calendarSelectors.refreshDateString(state.calendar),
		stagedChanges: calendarSelectors.refreshStagedChanges(state.calendar)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		updateCategories: (data) => dispatch(calendarActions.updateCategories(data)),
		updateStaged: (data) => dispatch(calendarActions.updateStaged(data)),
		resetStaged: () => dispatch(calendarActions.resetStaged())
	}
}
export default withFirebase(connect(
	mapStateToProps,
	mapDispatchToProps
)(ManageCalendarContainer));
